import { gql } from "@apollo/client";

const STATISTICS_HIGHTLIGHTS = gql`
  query highlightsData(
    $date: String
    $platform: Int
    $federationId: Int
    $startDate: String
    $endDate: String
  ) {
    highlightsData(
      date: $date
      platform: $platform
      federationId: $federationId
      endDate: $endDate
      startDate: $startDate
    )
  }
`;

export default STATISTICS_HIGHTLIGHTS;
